import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';

interface Props { 
    title: string; 
    icon?: React.ReactNode; 
    triggerFunction: any; 
    extraStyle?: any; 
    isDisabled?: boolean; 
}; 

const Button: React.FC<Props> = ({ title, icon, triggerFunction, extraStyle, isDisabled }) => {
    const { t } = useTranslation(); 
    const colors = useAppSelector(state => state.theme.colors); 

    const voidFunction = () => { 
        return; 
    }; 

    return (
        <Box
            onClick={isDisabled ? voidFunction : triggerFunction}
            sx={[{ 
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center', 
                // FIX: Changed from 'space-evenly' to 'center' for true centering
                justifyContent: 'center', 
                padding: 1, 
                fontSize: 14, 
                borderRadius: 1, 
                marginTop: 1, 
                paddingLeft: 2,
                paddingRight: 2, 
                height: 30,
                color: 'white', 
                cursor: isDisabled ? 'default' : 'pointer', 
                opacity: isDisabled ? 0.3 : 1, 
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                backgroundColor: colors?.main, 
                '&:hover': { backgroundColor: isDisabled ? colors?.main : colors?.mainHover },
                // FIX: Added a gap for clean spacing between icon and text
                gap: 0.5 
            }, extraStyle]}
        >
            {/* FIX: Simplified structure - no more nested flex containers */}
            {icon}
            {t(title)}
        </Box>
  );
};

export default Button;